import { render, staticRenderFns } from "./ModernMatterDimensionRow.vue?vue&type=template&id=67a0405f&scoped=true&"
import script from "./ModernMatterDimensionRow.vue?vue&type=script&lang=js&"
export * from "./ModernMatterDimensionRow.vue?vue&type=script&lang=js&"
import style0 from "./ModernMatterDimensionRow.vue?vue&type=style&index=0&id=67a0405f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a0405f",
  null
  
)

export default component.exports